import { SurveyTemplate, SurveyCategory } from '../types/Survey';

export const mockCategories: SurveyCategory[] = [
  {
    id: 'customer-satisfaction',
    name: '고객 만족도',
    description: '고객 서비스 품질 및 만족도 조사',
    icon: '😊',
    color: '#10b981',
    templateCount: 5
  },
  {
    id: 'employee-engagement',
    name: '직원 참여도',
    description: '직원 만족도 및 참여도 조사',
    icon: '👥',
    color: '#3b82f6',
    templateCount: 4
  },
  {
    id: 'product-feedback',
    name: '제품 피드백',
    description: '제품 사용 경험 및 개선사항',
    icon: '📱',
    color: '#8b5cf6',
    templateCount: 3
  },
  {
    id: 'event-evaluation',
    name: '이벤트 평가',
    description: '이벤트 참석자 피드백 및 평가',
    icon: '🎉',
    color: '#f59e0b',
    templateCount: 3
  },
  {
    id: 'market-research',
    name: '시장 조사',
    description: '시장 동향 및 소비자 행동 분석',
    icon: '📊',
    color: '#ef4444',
    templateCount: 4
  }
];

export const mockTemplates: SurveyTemplate[] = [
  {
    id: 'customer-satisfaction-basic',
    name: '기본 고객 만족도 조사',
    category: 'customer-satisfaction',
    description: '서비스 품질, 직원 응대, 전반적인 만족도를 측정하는 기본적인 설문',
    estimatedTime: 5,
    tags: ['고객', '만족도', '서비스'],
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-01-15'),
    isActive: true,
    usageCount: 150,
    questions: [
      {
        id: 'q1',
        type: 'rating',
        question: '저희 서비스에 대해 전반적으로 얼마나 만족하십니까?',
        required: true,
        minRating: 1,
        maxRating: 5
      },
      {
        id: 'q2',
        type: 'multiple-choice',
        question: '저희 서비스를 어떻게 알게 되셨나요?',
        options: ['검색엔진', '광고', '지인 추천', '소셜미디어', '기타'],
        required: true
      },
      {
        id: 'q3',
        type: 'text',
        question: '개선이 필요한 부분이 있다면 말씀해 주세요.',
        required: false
      }
    ]
  },
  {
    id: 'employee-engagement-annual',
    name: '연간 직원 참여도 조사',
    category: 'employee-engagement',
    description: '연간 직원 만족도, 참여도, 조직 문화를 종합적으로 평가',
    estimatedTime: 10,
    tags: ['직원', '참여도', '조직문화'],
    createdAt: new Date('2024-01-20'),
    updatedAt: new Date('2024-01-20'),
    isActive: true,
    usageCount: 89,
    questions: [
      {
        id: 'q1',
        type: 'rating',
        question: '현재 직장에서의 업무 만족도는 어느 정도입니까?',
        required: true,
        minRating: 1,
        maxRating: 5
      },
      {
        id: 'q2',
        type: 'matrix',
        question: '다음 항목들에 대해 평가해 주세요.',
        required: true,
        matrixRows: ['업무 환경', '동료와의 관계', '상사와의 관계', '업무량', '복리후생'],
        matrixColumns: ['매우 불만족', '불만족', '보통', '만족', '매우 만족'],
        matrixType: 'radio'
      },
      {
        id: 'q3',
        type: 'checkbox',
        question: '회사에서 개선되었으면 하는 부분을 모두 선택해 주세요.',
        options: ['급여', '근무시간', '업무환경', '교육기회', '승진기회', '소통', '복리후생'],
        required: false
      }
    ]
  },
  {
    id: 'product-feedback-mobile',
    name: '모바일 앱 사용성 조사',
    category: 'product-feedback',
    description: '모바일 앱의 사용성, 기능, 디자인에 대한 종합적인 피드백 수집',
    estimatedTime: 7,
    tags: ['모바일', '앱', '사용성'],
    createdAt: new Date('2024-01-25'),
    updatedAt: new Date('2024-01-25'),
    isActive: true,
    usageCount: 67,
    questions: [
      {
        id: 'q1',
        type: 'rating',
        question: '앱의 전반적인 사용성에 대해 평가해 주세요.',
        required: true,
        minRating: 1,
        maxRating: 5
      },
      {
        id: 'q2',
        type: 'ranking',
        question: '다음 기능들을 중요도 순으로 순위를 매겨주세요.',
        required: true,
        rankingItems: ['로그인/회원가입', '검색 기능', '알림', '설정', '고객지원']
      },
      {
        id: 'q3',
        type: 'file-upload',
        question: '개선이 필요한 화면이 있다면 스크린샷을 첨부해 주세요.',
        required: false,
        allowedFileTypes: ['.jpg', '.jpeg', '.png'],
        maxFileSize: 5
      }
    ]
  }
];

export const getTemplateById = (id: string): SurveyTemplate | undefined => {
  return mockTemplates.find(template => template.id === id);
};